export default __webpack_public_path__ + "static/media/petitplat.c4840083.jpg";